import { rgba } from 'polished';

import { Colours } from '@ratehub/base-ui';

import APPROVAL_LIKELIHOOD from '../definitions/ApprovalLikelihood';


export default {
    [APPROVAL_LIKELIHOOD.UNKNOWN]: {
        stroke: Colours.STONE_DARKEST,
        backgroundColour: Colours.STONE_LIGHTEST,
        borderColour: Colours.STONE_DARKEST,
    },
    [APPROVAL_LIKELIHOOD.POOR]: {
        stroke: Colours.STRAWBERRY_DARK,
        backgroundColour: Colours.WATERMELON_LIGHTEST,
        borderColour: Colours.STRAWBERRY_DARK,
    },
    [APPROVAL_LIKELIHOOD.FAIR]: {
        stroke: Colours.TANGERINE,
        backgroundColour: rgba(Colours.TANGERINE_LIGHTEST, 0.5),
        borderColour: Colours.TANGERINE,
    },
    [APPROVAL_LIKELIHOOD.GOOD]: {
        stroke: Colours.MINT_DARKEST,
        backgroundColour: Colours.MINT_LIGHT,
        borderColour: Colours.MINT_DARKEST,
    },
};
